'use strict'

import {
    Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
    dom,
    flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
    html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: "moskito-publishing-tree",
    properties: {
        data: {
            type: Array,
            notify: true
        },
        editable: {
            type: String,
            value: "false",
            notify: true
        }
    },
    hasNoChildren: function(p) {
        return (p.children[0] == null);
    },
    isEditable: function(e){
        return (e === "true");
    },
    handlePercentages: function(){
        var pa = document.querySelectorAll('.percentage');
        total = 0;
        [].forEach.call(pa, function(item){total += Math.round(item.value * 100) / 100;});
        document.querySelector('#total_percentage').value = Math.round(total);
    }
});
